import Colors from '../../../../shared/assets/style/default/color';
import styled from 'styled-components';

const AdsContainer = styled.div<React.CSSProperties>`
  background: ${Colors.background};
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 200; // On top of player
`;

export default AdsContainer;
